import { render } from "./TimeAllocatorModal.vue?vue&type=template&id=78f3ef88&scoped=true"
import script from "./TimeAllocatorModal.vue?vue&type=script&lang=js"
export * from "./TimeAllocatorModal.vue?vue&type=script&lang=js"

import "./TimeAllocatorModal.vue?vue&type=style&index=0&id=78f3ef88&scoped=true&lang=css"

import exportComponent from "/builds/weborigo-projects/vivien-vance/core-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78f3ef88"]])

export default __exports__